import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { EnvironmentInjector } from '@next/core-lib/environment';
import { Observable, of, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { Environment } from '../../../environment';
import { Concept, GetConceptsResponse } from './../models/flock-registration-service.model';

@Injectable({
  providedIn: 'root',
})
export class ConceptService {
  private readonly http = inject(HttpClient);
  private readonly env = inject<Environment>(EnvironmentInjector);

  private baseUrl = `${this.env.API_BASE_URL}/service/concept/secure/concept`;

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() {}

  public getConcepts(): Observable<Concept[] | HttpErrorResponse> {
    return this.http.get<GetConceptsResponse>(`${this.baseUrl}`).pipe(
      map((d) => d.concepts),
      catchError((error: HttpErrorResponse) => {
        if (error.status === 404) {
          return of(<Concept[]>[]);
        } else {
          return throwError({ message: error.message });
        }
      }),
    );
  }
}
